module.exports = __webpack_public_path__ + "static/img/21001.93e4d123.png";